import { render, staticRenderFns } from "./ExpiredCertificates.vue?vue&type=template&id=60e52bc7&"
import script from "./ExpiredCertificates.vue?vue&type=script&lang=js&"
export * from "./ExpiredCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e52bc7')) {
      api.createRecord('60e52bc7', component.options)
    } else {
      api.reload('60e52bc7', component.options)
    }
    module.hot.accept("./ExpiredCertificates.vue?vue&type=template&id=60e52bc7&", function () {
      api.rerender('60e52bc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dashboard/ExpiredCertificates.vue"
export default component.exports